import globalOptions from './globalOptions';
const _KST_MSEC = 1000 * 60 * 60 * 9;

function getDateFormat(period, isTooltip = false) {
    if (isTooltip) {
        if (period === 'minutes') return '%H:%M';
        return '%y.%m.%d'
    }

    if (period === 'minutes') return '%H';
    if (period === 'days') return '%m.%d';
    return '%m';
}

const mobileGlobalOptions = (Highcharts, options, colors) => {
    const defaultGlobalOptions = globalOptions(Highcharts, options, colors)
    return { 
        ...defaultGlobalOptions,
        chart: {
            ...defaultGlobalOptions.chart,
            panning: true,
            pinchType: 'x',
            marginRight: 60
        },
        scrollbar: {
            enabled: false
        },
        tooltip: {
            ...defaultGlobalOptions.tooltip,
            followTouchMove: false
        },
        xAxis: {
            ...defaultGlobalOptions.xAxis,
            labels: {
                formatter: function () {
                    return Highcharts.dateFormat(getDateFormat(this.chart.period), this.chart.dateLabels[this.value] + _KST_MSEC);
                }
            },
        }
    }
}

export default mobileGlobalOptions;